import { render, staticRenderFns } from "./TermChip.vue?vue&type=template&id=8eef5a2a&scoped=true&"
import script from "./TermChip.vue?vue&type=script&lang=js&"
export * from "./TermChip.vue?vue&type=script&lang=js&"
import style0 from "./TermChip.vue?vue&type=style&index=0&id=8eef5a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eef5a2a",
  null
  
)

export default component.exports